import type { Rule } from '@alerts/shared'

type Props = {
  rule: Rule
  onEdit: () => void
  onToggleEnabled: (next: boolean) => void
  onDelete: () => void
}

function marketColor(name: string): string {
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0
  const hue = ((h % 360) + 360) % 360
  return `hsl(${hue} 70% 60%)`
}

export function RuleCard({ rule, onEdit, onToggleEnabled, onDelete }: Props) {
  const count = rule.tickers.length * rule.timeframes.length * rule.pois.length * rule.types.length

  return (
    <div className="card" style={{ borderLeftColor: marketColor(rule.market) }}>
      <div className="between" style={{ marginBottom: 10 }}>
        <strong style={{ textTransform: 'capitalize' }}>{rule.market}</strong>
        <button type="button" className="link" onClick={onEdit}>
          {count} alerts · Edit ›
        </button>
      </div>

      <div className="label" style={{ marginBottom: 4 }}>Tickers · {rule.tickers.length}</div>
      <div className="row">
        {rule.tickers.map((t) => (
          <span key={t} className="chip on">{t}</span>
        ))}
      </div>

      <div className="label" style={{ marginBottom: 4 }}>TF · {rule.timeframes.length}</div>
      <div className="row">
        {rule.timeframes.map((t) => (
          <span key={t} className="chip on">{t}</span>
        ))}
      </div>

      <div className="label" style={{ marginBottom: 4 }}>
        POI · {rule.pois.length} · Type · {rule.types.length}
      </div>
      <div className="row">
        {[...rule.pois, ...rule.types].map((t) => (
          <span key={t} className="chip on">{t}</span>
        ))}
      </div>

      <div className="between" style={{ marginTop: 10 }}>
        <button type="button" className="link" onClick={() => onToggleEnabled(!rule.enabled)}>
          {rule.enabled ? '⏸ Pause this market' : '▶ Resume this market'}
        </button>
        <button type="button" className="link danger" onClick={onDelete}>
          🗑 Delete
        </button>
      </div>
    </div>
  )
}
